function FacturacionView({
  showAutomationPulse,
  setShowAutomationPulse,
  activeLabel,
  isUsingLiveData,
  canOpenAirtable,
  handleOpenAirtableEmbed,
  tableFilters,
  updateTableFilter,
  searchTerm,
  handleSearchChange,
  estadoFilterOptions,
  metodoPagoFilterOptions,
  contactoFilterOptions,
  pendientePagoOptions,
  responsableFilterOptions,
  scopeOptions,
  activeScope,
  handleScopeChange,
  filterSummaryText,
  hasActiveFilters,
  handleClearFilters,
  loadingRecords,
  errorRecords,
  requestsToDisplay,
  canManageRequestStatuses,
  requestStatusOptions,
  updatingRequestStatusById,
  requestStatusFeedbackById,
  handleRequestStatusChange,
  N8N_APP_URL,
  handleRefreshLogs,
  loadingLogs,
  logsError,
  logs
}) {
  return (
    <main
      className={`content-grid ${showAutomationPulse ? '' : 'pulse-collapsed'}`.trim()}
      data-ui-view="facturacion"
      data-ui-section="facturacion-view"
    >
      <section className="board" data-ui-section="facturacion-board">
        <div className="section-header">
          <div>
            <h3>Solicitudes en curso</h3>
            <p>Seguimiento operativo para solicitudes pendientes, aprobadas, generadas y enviadas.</p>
          </div>
          <div className="section-actions">
            <span className={`data-pill ${isUsingLiveData ? 'live' : 'mock'}`}>
              {isUsingLiveData ? 'Datos en vivo' : 'Datos de ejemplo'}
            </span>
            <button
              className="btn ghost"
              type="button"
              onClick={() => setShowAutomationPulse(prev => !prev)}
              aria-expanded={showAutomationPulse}
              aria-controls="automation-pulse-panel"
              data-ui-action="toggle-automation-pulse"
            >
              {showAutomationPulse ? 'Ocultar pulso n8n' : 'Mostrar pulso n8n'}
            </button>
            {canOpenAirtable && (
              <button className="btn ghost" onClick={handleOpenAirtableEmbed} data-ui-action="open-airtable-embed">
                Abrir en Airtable
              </button>
            )}
          </div>
        </div>

        <div className="scope-strip" data-ui-section="facturacion-scope-strip">
          {scopeOptions.map(option => (
            <button
              key={option.key}
              type="button"
              className={`scope-pill ${activeScope === option.key ? 'active' : ''}`}
              onClick={() => handleScopeChange(option.key)}
            >
              <span>{option.label}</span>
              <strong>{option.count}</strong>
            </button>
          ))}
        </div>

        <div className="table-filters table-filters-sticky" data-ui-section="facturacion-filters">
          <label className="filter-control">
            <span>Estado de solicitud</span>
            <select value={tableFilters.estado} onChange={event => updateTableFilter('estado', event.target.value)}>
              {estadoFilterOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
          <label className="filter-control">
            <span>Método de pago</span>
            <select
              value={tableFilters.metodoPago}
              onChange={event => updateTableFilter('metodoPago', event.target.value)}
            >
              {metodoPagoFilterOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
          <label className="filter-control">
            <span>Contacto preferido</span>
            <select value={tableFilters.contacto} onChange={event => updateTableFilter('contacto', event.target.value)}>
              {contactoFilterOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
          <label className="filter-control">
            <span>Estado de pago</span>
            <select
              value={tableFilters.pendientePago}
              onChange={event => updateTableFilter('pendientePago', event.target.value)}
            >
              {pendientePagoOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
          <label className="filter-control">
            <span>Responsable</span>
            <select value={tableFilters.responsable} onChange={event => updateTableFilter('responsable', event.target.value)}>
              {responsableFilterOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
          <label className="filter-control search-control">
            <span>Búsqueda operativa</span>
            <input
              type="search"
              placeholder="Folio, RFC, ticket/OC, documento, periodo, correo, WhatsApp o responsable"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </label>
          <div className="filter-summary-row">
            <p className="helper-text">{filterSummaryText}</p>
            {hasActiveFilters && (
              <button className="btn ghost compact" type="button" onClick={handleClearFilters}>
                Limpiar filtros
              </button>
            )}
          </div>
        </div>

        <div className="board-table board-table-keyvalue-mobile" data-ui-section="facturacion-table">
          {loadingRecords && (
            <div className="table-loading">
              <div className="loader" aria-label="Cargando datos">
                <span className="loader-dot" />
                <span className="loader-dot" />
                <span className="loader-dot" />
              </div>
            </div>
          )}
          <div className="table-head">
            <span>Folio</span>
            <span>Contribuyente</span>
            <span>Estado</span>
            <span>Contacto</span>
            <span>Total</span>
            <span>Responsable</span>
            <span>Última actividad</span>
          </div>
          {!loadingRecords && errorRecords && <p className="helper-text error">{errorRecords}</p>}
          {!loadingRecords && !errorRecords && !requestsToDisplay.length && (
            <p className="helper-text">No encontramos registros con los filtros aplicados.</p>
          )}
          {requestsToDisplay.map(req => {
            const statusClass = (req.estado || '').toLowerCase().replace(/\s+/g, '-');
            const isUpdatingStatus = Boolean(updatingRequestStatusById?.[req.airtableRecordId]);
            const statusFeedback = requestStatusFeedbackById?.[req.airtableRecordId] || null;
            const rowCells = (
              <>
                <strong data-cell-label="Folio">{req.folio}</strong>
                <span data-cell-label="Contribuyente">{req.clienteVisible}</span>
                <div className="status-cell" data-cell-label="Estado">
                  {canManageRequestStatuses ? (
                    <>
                      <label className={`status-select-shell ${statusClass}`}>
                        <span className="sr-only">Cambiar estado de la solicitud {req.folio}</span>
                        <select
                          className="status-select-input"
                          value={req.estado}
                          onChange={event => handleRequestStatusChange(req.airtableRecordId, event.target.value)}
                          disabled={isUpdatingStatus}
                          aria-label={`Cambiar estado de la solicitud ${req.folio}`}
                        >
                          {requestStatusOptions.map(option => (
                            <option key={`status-option-${req.airtableRecordId}-${option.value}`} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </label>
                      {isUpdatingStatus && <span className="status-inline-message">Guardando…</span>}
                      {!isUpdatingStatus && statusFeedback && (
                        <span className={`status-inline-message ${statusFeedback.type}`}>{statusFeedback.message}</span>
                      )}
                    </>
                  ) : (
                    <span className={`status chip ${statusClass}`}>{req.estado}</span>
                  )}
                </div>
                <span data-cell-label="Contacto">{req.contacto}</span>
                <span data-cell-label="Total">{req.total}</span>
                <span data-cell-label="Responsable">{req.responsable}</span>
                <div className="table-row-meta" data-cell-label="Última actividad">
                  <span>{req.actualizado}</span>
                  {canManageRequestStatuses && req.primaryLinkUrl && (
                    <a
                      className="table-row-inline-link"
                      href={req.primaryLinkUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {req.primaryLinkLabel || 'Abrir recurso'}
                    </a>
                  )}
                </div>
              </>
            );
            return req.primaryLinkUrl && !canManageRequestStatuses ? (
              <a
                key={req.airtableRecordId || req.folio}
                className="table-row link-row"
                href={req.primaryLinkUrl}
                target="_blank"
                rel="noreferrer"
                aria-label={req.primaryLinkLabel || 'Abrir recurso relacionado a la solicitud'}
              >
                {rowCells}
              </a>
            ) : (
              <div key={req.airtableRecordId || req.folio} className="table-row">
                {rowCells}
              </div>
            );
          })}
        </div>
      </section>

      {showAutomationPulse && (
        <aside className="side-panel" id="automation-pulse-panel" data-ui-section="facturacion-pulse-panel">
          <section className="logs">
            <div className="section-header">
              <div>
                <h3>Pulso de automatizaciones</h3>
                <p>Ejecuciones n8n ({activeLabel?.toLowerCase()})</p>
              </div>
              <div className="section-actions">
                <a className="btn ghost" href={N8N_APP_URL} target="_blank" rel="noreferrer">
                  n8n
                </a>
                <button className="btn ghost" type="button" onClick={handleRefreshLogs} disabled={loadingLogs}>
                  {loadingLogs ? 'Actualizando…' : 'Actualizar'}
                </button>
                <button className="btn ghost" type="button" onClick={() => setShowAutomationPulse(false)}>
                  Contraer
                </button>
              </div>
            </div>
            {loadingLogs && <p className="helper-text">Cargando ejecuciones de n8n…</p>}
            {!loadingLogs && logsError && <p className="helper-text error">{logsError}</p>}
            {!loadingLogs && !logsError && !logs.length && (
              <p className="helper-text">No hay ejecuciones para mostrar en este rango.</p>
            )}
            <div className="logs-list">
              {logs.map((item, index) => {
                const summarySegments = [];
                if (item.detalle) summarySegments.push(item.detalle);
                if (item.resumen) summarySegments.push(item.resumen);
                if (!summarySegments.length && item.id) {
                  summarySegments.push(`Ejecución #${item.id}`);
                }
                const summaryText = summarySegments.join(' · ');
                const triggerLabel = item.triggerLabel || '';
                return (
                  <article key={`${item.id || 'log'}-${index}`} className="log-item">
                    <div className="log-header">
                      <span className={`badge ${item.estadoClass || (item.estado || '').toLowerCase()}`}>
                        {item.estado}
                      </span>
                      <span className="log-duration">{item.duracion || '—'}</span>
                    </div>
                    <strong className="log-title">
                      {item.url ? (
                        <a href={item.url} target="_blank" rel="noreferrer">
                          {item.flujo}
                        </a>
                      ) : (
                        item.flujo
                      )}
                    </strong>
                    <p className="log-message">{item.mensaje}</p>
                    {(summaryText || triggerLabel) && (
                      <div className="log-footer">
                        {summaryText && <small>{summaryText}</small>}
                        {triggerLabel && <span className="log-trigger">{triggerLabel}</span>}
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </section>
        </aside>
      )}
    </main>
  );
}

export default FacturacionView;
